module.exports = __webpack_public_path__ + "static/media/account-grey.d1fa58ba.svg";